// GENERATED FILE — do not edit by hand.
// Source: server/src/billing/policy/plan_catalog_v2026_09_06.js
//         + server/src/billing/catalog/price_catalog_v2026_09_06.js
// Regenerate: cd server && npm run generate:plan-policy-dart
//
// DISPLAY-ONLY. Currency UI changes only offerKey selection — never amounts
// or Stripe Price IDs. Server entitlement engine is authoritative.

export const kStratifyPlanPolicyVersion = "2026-09-24.1";
export const kStratifyPlanPolicySchemaVersion = 1;
export const kStratifyPriceCatalogVersion = "2026-09-06.1";
export const kEliteUncertifiedActivePaperBotsCap = 5;

export const StratifyPlanCapabilities = {
  "brokerReadOnlyConnect": "broker.read_only.connect",
  "paperBotActivate": "paper_bot.activate",
  "paperBotTimeframe1w": "paper_bot.timeframe.1w",
  "paperBotTimeframe1d": "paper_bot.timeframe.1d",
  "paperBotTimeframe4h": "paper_bot.timeframe.4h",
  "paperBotTimeframe1h": "paper_bot.timeframe.1h",
  "paperBotTimeframe30m": "paper_bot.timeframe.30m",
  "paperBotTimeframe15m": "paper_bot.timeframe.15m",
  "paperBotTimeframe5m": "paper_bot.timeframe.5m",
  "discoveryBasic": "discovery.basic",
  "discoveryAdvanced": "discovery.advanced",
  "discoveryFullPower": "discovery.full_power",
  "discoveryTimeframe1w": "discovery.timeframe.1w",
  "discoveryTimeframe1d": "discovery.timeframe.1d",
  "discoveryTimeframe4h": "discovery.timeframe.4h",
  "discoveryTimeframe1h": "discovery.timeframe.1h",
  "discoveryTimeframe30m": "discovery.timeframe.30m",
  "discoveryTimeframe15m": "discovery.timeframe.15m",
  "optimizerRun": "optimizer.run",
  "optimizerTimeframe1w": "optimizer.timeframe.1w",
  "optimizerTimeframe1d": "optimizer.timeframe.1d",
  "optimizerTimeframe4h": "optimizer.timeframe.4h",
  "eventCompanyBasic": "event.company.basic",
  "eventCompanyFull": "event.company.full",
  "eventMarketMacro": "event.market_macro",
  "eventPush": "event.push",
  "eventDailyDigest": "event.daily_digest",
  "eventResults": "event.results"
};

export const kStratifyPlanPolicyDisplayCatalog = {
  "free": {
    "planId": "free",
    "displayName": "Free",
    "rank": 0,
    "discoveryLevel": "basic",
    "limits": {
      "activePaperBots": 2,
      "extraSavedStrategies": 5,
      "watchlistSymbols": 10,
      "discoveryRunsPerUtcDay": 3,
      "optimizerVariantsPerRun": 80,
      "activeCompanyEventRules": 5
    },
    "paperBotTimeframes": [
      "1W",
      "1D",
      "4H",
      "1H",
      "30m",
      "15m",
      "5m"
    ],
    "discoveryTimeframes": [
      "1W",
      "1D",
      "4H",
      "1H",
      "30m",
      "15m"
    ],
    "optimizerTimeframes": [
      "1W",
      "1D",
      "4H"
    ],
    "capabilities": [
      "paper_bot.activate",
      "paper_bot.timeframe.1w",
      "paper_bot.timeframe.1d",
      "paper_bot.timeframe.4h",
      "paper_bot.timeframe.1h",
      "paper_bot.timeframe.30m",
      "paper_bot.timeframe.15m",
      "paper_bot.timeframe.5m",
      "discovery.basic",
      "discovery.timeframe.1w",
      "discovery.timeframe.1d",
      "discovery.timeframe.4h",
      "discovery.timeframe.1h",
      "discovery.timeframe.30m",
      "discovery.timeframe.15m",
      "optimizer.run",
      "optimizer.timeframe.1w",
      "optimizer.timeframe.1d",
      "optimizer.timeframe.4h",
      "event.company.basic"
    ],
    "eventPushAllowed": false,
    "companyBasicInAppOnly": true
  },
  "pro": {
    "planId": "pro",
    "displayName": "Stratify Pro",
    "rank": 10,
    "discoveryLevel": "advanced",
    "limits": {
      "activePaperBots": 5,
      "extraSavedStrategies": 25,
      "watchlistSymbols": 50,
      "discoveryRunsPerUtcDay": 20,
      "optimizerVariantsPerRun": 2500,
      "activeCompanyEventRules": 50
    },
    "paperBotTimeframes": [
      "1W",
      "1D",
      "4H",
      "1H",
      "30m",
      "15m",
      "5m"
    ],
    "discoveryTimeframes": [
      "1W",
      "1D",
      "4H",
      "1H",
      "30m",
      "15m"
    ],
    "optimizerTimeframes": [
      "1W",
      "1D",
      "4H"
    ],
    "capabilities": [
      "broker.read_only.connect",
      "paper_bot.activate",
      "paper_bot.timeframe.1w",
      "paper_bot.timeframe.1d",
      "paper_bot.timeframe.4h",
      "paper_bot.timeframe.1h",
      "paper_bot.timeframe.30m",
      "paper_bot.timeframe.15m",
      "paper_bot.timeframe.5m",
      "discovery.basic",
      "discovery.advanced",
      "discovery.timeframe.1w",
      "discovery.timeframe.1d",
      "discovery.timeframe.4h",
      "discovery.timeframe.1h",
      "discovery.timeframe.30m",
      "discovery.timeframe.15m",
      "optimizer.run",
      "optimizer.timeframe.1w",
      "optimizer.timeframe.1d",
      "optimizer.timeframe.4h",
      "event.company.basic",
      "event.company.full",
      "event.market_macro",
      "event.push",
      "event.daily_digest",
      "event.results"
    ],
    "eventPushAllowed": true,
    "companyBasicInAppOnly": false
  },
  "elite": {
    "planId": "elite",
    "displayName": "Stratify Elite",
    "rank": 20,
    "discoveryLevel": "full_power",
    "limits": {
      "activePaperBots": 15,
      "extraSavedStrategies": 100,
      "watchlistSymbols": 150,
      "discoveryRunsPerUtcDay": 50,
      "optimizerVariantsPerRun": 7200,
      "activeCompanyEventRules": 250
    },
    "paperBotTimeframes": [
      "1W",
      "1D",
      "4H",
      "1H",
      "30m",
      "15m",
      "5m"
    ],
    "discoveryTimeframes": [
      "1W",
      "1D",
      "4H",
      "1H",
      "30m",
      "15m"
    ],
    "optimizerTimeframes": [
      "1W",
      "1D",
      "4H"
    ],
    "capabilities": [
      "broker.read_only.connect",
      "paper_bot.activate",
      "paper_bot.timeframe.1w",
      "paper_bot.timeframe.1d",
      "paper_bot.timeframe.4h",
      "paper_bot.timeframe.1h",
      "paper_bot.timeframe.30m",
      "paper_bot.timeframe.15m",
      "paper_bot.timeframe.5m",
      "discovery.basic",
      "discovery.advanced",
      "discovery.full_power",
      "discovery.timeframe.1w",
      "discovery.timeframe.1d",
      "discovery.timeframe.4h",
      "discovery.timeframe.1h",
      "discovery.timeframe.30m",
      "discovery.timeframe.15m",
      "optimizer.run",
      "optimizer.timeframe.1w",
      "optimizer.timeframe.1d",
      "optimizer.timeframe.4h",
      "event.company.basic",
      "event.company.full",
      "event.market_macro",
      "event.push",
      "event.daily_digest",
      "event.results"
    ],
    "eventPushAllowed": true,
    "companyBasicInAppOnly": false
  }
};

export const kStratifyPlanPolicyDisplayOffers = [
  {
    "offerKey": "stratify_pro_monthly_usd_v1",
    "planId": "pro",
    "currency": "usd",
    "interval": "month",
    "unitAmountMinor": 1999
  },
  {
    "offerKey": "stratify_pro_annual_usd_v1",
    "planId": "pro",
    "currency": "usd",
    "interval": "year",
    "unitAmountMinor": 19999
  },
  {
    "offerKey": "stratify_pro_monthly_cad_v1",
    "planId": "pro",
    "currency": "cad",
    "interval": "month",
    "unitAmountMinor": 2799
  },
  {
    "offerKey": "stratify_pro_annual_cad_v1",
    "planId": "pro",
    "currency": "cad",
    "interval": "year",
    "unitAmountMinor": 27999
  },
  {
    "offerKey": "stratify_elite_monthly_usd_v1",
    "planId": "elite",
    "currency": "usd",
    "interval": "month",
    "unitAmountMinor": 3999
  },
  {
    "offerKey": "stratify_elite_annual_usd_v1",
    "planId": "elite",
    "currency": "usd",
    "interval": "year",
    "unitAmountMinor": 39999
  },
  {
    "offerKey": "stratify_elite_monthly_cad_v1",
    "planId": "elite",
    "currency": "cad",
    "interval": "month",
    "unitAmountMinor": 5499
  },
  {
    "offerKey": "stratify_elite_annual_cad_v1",
    "planId": "elite",
    "currency": "cad",
    "interval": "year",
    "unitAmountMinor": 54999
  }
];

export function stratifyPlanPolicyDisplayFor(planId) {
  return kStratifyPlanPolicyDisplayCatalog[planId] || null;
}

export function stratifyPlanPolicyOfferFor(offerKey) {
  return (
    kStratifyPlanPolicyDisplayOffers.find((o) => o.offerKey === offerKey) ||
    null
  );
}

/**
 * Resolve display offer from currency + interval toggles.
 * Amounts come only from the catalog row selected by offerKey.
 */
export function stratifyPlanPolicyOfferForPlanCurrencyInterval(
  planId,
  currency,
  interval
) {
  const cur = String(currency || "").toLowerCase();
  const iv = String(interval || "").toLowerCase();
  return (
    kStratifyPlanPolicyDisplayOffers.find(
      (o) =>
        o.planId === planId &&
        o.currency.toLowerCase() === cur &&
        o.interval.toLowerCase() === iv
    ) || null
  );
}

export function formatOfferPrice(offer) {
  if (!offer) return "";
  const major = offer.unitAmountMinor / 100;
  const symbol = String(offer.currency).toLowerCase() === "cad" ? "CA$" : "$";
  const body =
    major === Math.round(major) ? String(Math.round(major)) : major.toFixed(2);
  const period = offer.interval === "year" ? "/yr" : "/mo";
  return symbol + body + period;
}

export function planLimit(plan, key) {
  if (!plan || !plan.limits) return 0;
  return Number(plan.limits[key] || 0);
}

export function planHasCapability(plan, capability) {
  return Boolean(plan?.capabilities?.includes(capability));
}
